import { app } from '../../../../app';
import { Controller } from './software-license-management.list.controller';

app.component('softwareLicenseManagementList', {
    bindings: {softwareLicenseManagementInfos: '<'},
    controller: Controller,
    templateUrl: require('./software-license-management.list.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/software-license-management/list/software-license-management.list.component.js